// src/i18n.js

import Vue from "vue";
import VueI18n from "vue-i18n";
import requestErrors from "./i18n/request-errors";

Vue.use(VueI18n);

const messages = {
  la: {},
  en: {
    requestErrors: requestErrors.en,
    navigation: {
      heading: `Evaluation Portal for Course Participants`,
      language: {
        label: `Language`,
        english: `English`,
        german: `German`,
        labels: `labels`,
      },
    },
    common: {
      external: `External`,
      loading: `Loading`,
      unitDay: `Day`,
      unitDayPl: `Days`,
      unitDayAdj: ` Day`,
      room: `Room`,
      submit: `Submit`,
      yes: `Yes`,
      no: `No`,
      backToOverview: `Back to Overview`,
      backToForm: `Back to Form`,
      addedToNewsletter: `You have been added to the newsletter.`,
      newsletterJoin: `You have joined our newsletter.`,
      newsletterFailed: `We could not add you to the newsletter:`,
      reviewThanks: `Thank you for your review!`,
      reviewSuccess: `We have received your review`,
      reviewFailed: `Could not create review:`,
    },
    rooms: {
      header: {
        quote: `Anyone who stops improving <br>has stopped being good!`,
        author: `Philip Rosenthal`,
        conclusion: `We want to improve. <br>For that, we need your feedback!`,
      },
      lead: {
        salutation: `Dear Course Participant,`,
        introduction: `The satisfaction of our participants is extremely important to us. Therefore, we kindly ask you to take a moment to provide us with your feedback. It only takes a few minutes and is very valuable to us. Please select your course!`,
      },
      chooseSeminar: `Select your course`,
      erorMessages: {
        noRooms: `Could not load rooms.`,
        noLinks: `Could not assign links to the rooms.`,
        noReviews: `No evaluations today.`,
      },
    },
    notFound: {
      errorCode: `404`,
      title: `Page not found`,
      description: `The requested evaluation form could not be found.`,
      cameFromLabel: `You were redirected from:`,
      helpText: `Please check the URL or contact our support.`,
      supportButton: `Contact Support`,
      emailSubject: `Evaluation link could not be opened`,
      emailBody: {
        greeting: `Hello Support Team,`,
        problem: `I was unable to access the evaluation link.`,
        linkLabel: `Link accessed:`,
        closing: `Please check the problem.`,
        regards: `Best regards`,
      },
    },
    //RatingForm
    ratingForm: {
      header: {
        label: `Evaluation for`,
      },
      booking: {
        label: `Select your name:<small style="font-size:.95em"> (You can anonymize below)</small>`,
        choose: `Select name...`,
      },
      email: {
        label: `We do not have your email address yet`,
      },
      trainer: {
        rating: {
          label: `How do you evaluate the performance of your <span class="marked">Trainer</span> ?`,
          method: `From a methodological perspective`,
          subject: `From a professional perspective`,
        },
        comment: {
          label: `What was the reason for your evaluation?`,
          placeholder: `Enter Comment...`,
          guidance: {
            label: `Guidance for your evaluation`,
            h1: `Describe the performance of your trainer`,
            h2: `How did you find the structure and methodology?`,
            h3: `Did your trainer address your questions?`,
          },
        },
      },
      seminar: {
        rating: {
          label: `How do you rate your <span class="marked">course</span> ?`,
        },
        comment: {
          label: `What was the reason for your evaluation?`,
          placeholder: `Enter Comment...`,
          guidance: {
            label: `Guidance for your evaluation`,
            h1: `What do you think of the quality of your course?`,
            h2: `Did the course meet your expectations?`,
            h3: `How did you find the materials and technology?`,
            h4: `How will the course improve your productivity at work?`,
          },
        },
      },
      gfu: {
        rating: {
          label: `How satisfied are you with <span class="marked">GFU</span> as a training provider?`,
        },
        comment: {
          label: `Please describe your experience with GFU`,
          placeholder: `Enter Comment...`,
          guidance: {
            label: `Guidance for your evaluation`,
            h1: `How satisfied are you with the booking process and the organization of the training?`,
            h2: `What are you particularly satisfied with, and what could be improved?`,
            h3: `Why would you recommend the company?`,
          },
        },
      },
      furtherInterest: {
        label: `What training topics are you interested in for the future?`,
        placeholder: "Enter Comment...",
        guidance: {
          label: `The GFU offers 1800+ courses in`,
          h1: `Cloud`,
          h2: `Data Science`,
          h3: `Programming`,
          h4: `Web Technologies`,
          h5: `Operating Systems`,
          h6: `Databases`,
          h7: `Applications`,
          h8: `Server Services`,
          h9: `Projectmanagement`,
          h10: `Personal Development`,
        },
      },
      anonymization: {
        label: `Display of your evaluation in our marketing channels`,
        name: {
          label: `May we display your name?`,
          optionFullName: {
            label: `Full Name`,
            sample: `John Doe`,
          },
          optionAbbreviated: {
            label: `Abbreviated`,
            sample: `John D.`,
          },
          optionHideName: {
            label: `Hide name`,
            sample: ``,
          },
        },
        company: {
          label: `May we display your company's name?`,
          optionYes: {
            label: `Yes`,
            sample: `Sample Inc.`,
          },
          optionNo: {
            label: `No`,
            sample: ``,
          },
        },
      },

      suggestions: {
        label: `What advice would you give to the GFU team for even better performance`,
        appendum: `and what role should AI play in this going forward, from your perspective?`, 
      },
      sampleReviews: {
        label: `Typical evaluations in recent times`,
        showMore: `show more`,
        r1: `The training exceeded my expectations. The quality was consistently high, with a lot of practical know-how. Very good explanations and solid technical background. A high practical relevance was provided. The theoretical background was explained very well and clearly. Good technical equipment in the rooms, very good catering, and the 86" monitors worked surprisingly well instead of a projector.`,
        r2: `The impressive catering, the friendly and accommodating staff, and the truly reliable training computers created a perfect image of GFU, so I will definitely recommend them.`,
        r3: `Everything was perfectly organized. Good training materials. Good course. Delicious coffee and snacks. The TÜV cafeteria is amazing, even though it was always too much food.`,
        r4: `This is now my 12th visit to GFU, and I wouldn't know what could be improved. The provision of food and drinks is at a Champions League level :)`,
        r5: `+ The coffee is super delicious.<br />
          + The food was always at least average, rather better than average.<br />
          + A shuttle would take you to or pick you up from the train station.<br />
          + Everyone here is very nice and helpful.<br />
          + Everything is provided, and you never need to bring anything.<br />
          !!!! Everything is simply top-notch !!!!!`,
        r6: `GFU made an excellent impression. The training environment, support for course participants, and the trainer were all at an absolute top level. I would be happy to recommend GFU at any time.`,
        r7: `Perfect organization. Training rooms are excellently equipped, catering is 'incredibly good,' and the GFU staff are super friendly :)<br />Recommendation? Definitely`,
        r8: `- Perfectly organized<br />
          - Many goodies like free books, snack bar, drinks<br />
          - Shuttle service<br />
          - Very good cafeteria that can be used for free.<br />
          - Pleasant climate despite summer<br />
          - Good hardware (PCs)`,
        r9: `The training was very practical, well-structured, and educational. The instructor had a lot of practical experience and could adapt well to the participants' backgrounds, providing suitable examples and solutions for each participant's situation "out of the hat."`,
        r10: `GFU is a very good location with excellent trainers and well-equipped rooms. The great catering also deserves mention.`,
      },
      validation: {
        required: `is required`,
        fields: {
          trainerRating1: `Rating`,
          trainerRating2: `Rating`,
          seminarRating: `Course-Rating`,
          gfuRating: `GFU-Rating`,
        },
      },
    },
    newsletter: {
      legend: `Don’t Miss a Trend!`,
      freeBook: `Free Professional Book`,
      introduction: {
        heading: `€50 Book Voucher for Newsletter Subscribers`,
        text: `Sign up for our free newsletter and receive a €50 book voucher for a professional book of your choice - redeemable on your next training visit to GFU Cyrus AG.`,
      },
      subscribe: {
        label: `May we sign you up for our newsletter?`,
      },
      form: {
        label: `Email`,
        placeholder: `Enter email...`,
        option1: {
          heading: `Book Voucher`,
          text: `Yes, I would like to receive a €50 book voucher for my newsletter subscription. I confirm that I am not a public official as defined in § 11 Abs. 1 Nr. 2 StGB. Furthermore, I confirm that my employer has not prohibited me from accepting benefits.`,
        },
        option2: {
          heading: `Standard Newsletter`,
          text: `I agree that GFU Cyrus AG may store and use my above data to send their <strong>general newsletter</strong> and other
  <strong>general marketing communication</strong> (information about trainings, lectures & events, articles, contests,
  promotions, etc.). I can withdraw my consent for data processing for advertising purposes at any time with effect for
  the future by clicking the unsubscribe link in the promotional email or sending an email to <a
    href="mailto:newsletterabmeldung@gfu.net">newsletterabmeldung@gfu.net</a>. I have taken note of the <a
    href="https://www.gfu.net/datenschutz.html">privacy policy</a>.`,
        },
        option3: {
          heading: `Standard + Personalized Newsletter`,
          text: `I agree that GFU Cyrus AG may store and use my above data to send their general newsletter and other general
    marketing communication, as well as additional data (e.g., regarding my previous course visits and newsletter click
    behavior, for further details see the <a href="https://www.gfu.net/datenschutz.html">privacy policy</a>) for sending
    a <strong>personalized newsletter</strong> tailored to my interests and other <strong>personalized marketing
      communication</strong> (information about trainings, lectures & events, articles, contests, promotions, etc.). I
    can withdraw my consent for data processing for advertising purposes at any time with effect for the future by
    clicking the unsubscribe link in the promotional email or sending an email to <a
      href="mailto:newsletterabmeldung@gfu.net">newsletterabmeldung@gfu.net</a>. I have taken note of the <a
      href="https://www.gfu.net/datenschutz.html">privacy policy</a>.`,
        },
      },
    },
  },
  de: {
    requestErrors: requestErrors.de,
    navigation: {
      heading: `Bewertungsportal für Seminarteilnehmende`,
      language: {
        label: `Sprache`,
        english: `Englisch`,
        german: `Deutsch`,
        labels: `labels`,
      },
    },
    common: {
      external: `Extern`,
      loading: `Lade Daten`,
      unitDay: `Tag`,
      unitDayPl: `Tage`,
      unitDayAdj: `-tägig`,
      room: `Raum`,
      submit: `Absenden`,
      yes: `Ja`,
      no: `Nein`,
      backToOverview: `Zurück zur Übersicht`,
      backToForm: `Zurück zum Formular`,
      addedToNewsletter: `Sie wurden in den Newsletterverteiler eingetragen`,
      newsletterJoin: `Sie haben sich für unseren Newsletter eingetragen`,
      newsletterFailed: `Wir konnten Sie nicht in den Newsletterverteiler aufnehmen:`,
      reviewThanks: `Vielen Dank für Ihre Bewertung!`,
      reviewSuccess: `Wir haben Ihre Bewertung erhalten`,
      reviewFailed: `Konnte Bewertung nicht erstellen:`,
    },
    rooms: {
      header: {
        quote: `Wer aufhört, besser zu werden, <br>hat aufgehört, gut zu sein!`,
        author: `Philip Rosenthal`,
        conclusion: `Wir wollen besser werden. <br>Dazu brauchen wir Ihr Feedback!`,
      },
      lead: {
        salutation: `Liebe Seminarteilnehmerin, lieber Seminarteilnehmer,`,
        introduction: `die Zufriedenheit unserer Teilnehmer:innen ist uns extrem wichtig. Wir möchten Sie daher bitten, sich kurz die Zeit zu nehmen, um uns Ihr Feedback zu geben. Das dauert nur wenige Minuten und ist sehr wertvoll für uns. Bitte wählen Sie hierzu Ihr Seminar aus!`,
      },
      chooseSeminar: `Wählen Sie Ihr Seminar aus`,
      erorMessages: {
        noRooms: `Konnte Räume nicht laden.`,
        noLinks: `Konnte den Räumen keine Links zuordnen.`,
        noReviews: `Keine Bewertungen heute.`,
      },
    },
    notFound: {
      errorCode: `404`,
      title: `Seite nicht gefunden`,
      description: `Das gewünschte Bewertungsformular konnte leider nicht gefunden werden.`,
      cameFromLabel: `Sie wurden weitergeleitet von:`,
      helpText: `Bitte überprüfen Sie die URL oder kontaktieren Sie unseren Support.`,
      supportButton: `Support kontaktieren`,
      emailSubject: `Bewertungslink konnte nicht aufgerufen werden`,
      emailBody: {
        greeting: `Hallo Support-Team,`,
        problem: `ich konnte den Bewertungslink nicht aufrufen.`,
        linkLabel: `Aufgerufener Link:`,
        closing: `Bitte prüfen Sie das Problem.`,
        regards: `Mit freundlichen Grüßen`,
      },
    },
    //RatingForm
    ratingForm: {
      header: {
        label: `Bewertung für`,
      },
      booking: {
        label: `Wählen Sie Ihren Namen aus:<small style="font-size:.95em"> (Können Sie unten anonymisieren)</small>`,
        choose: `Auswählen...`,
      },
      email: {
        label: `Wir haben noch keine E-Mail-Adresse von Ihnen`,
      },
      trainer: {
        rating: {
          label: `Wie beurteilen Sie die Leistung Ihres <span class="marked">Trainers</span> ?`,
          method: `Aus methodischer Sicht`,
          subject: `Aus fachlicher Sicht`,
        },
        comment: {
          label: `Was war der Grund, der zu Ihrer Bewertung geführt hat?`,
          placeholder: `Kommentar eingeben...`,
          guidance: {
            label: `Hilfestellung für Ihre Bewertung`, //nach dem doppelpunkt gucken war inkonsistent
            h1: `Beschreiben Sie die Leistung Ihres Trainers`,
            h2: `Wie fanden Sie Strukturierung und Methodik?`,
            h3: `Ist Ihr Trainer auf Fragen eingegangen?`,
          },
        },
      },
      seminar: {
        rating: {
          label: `Wie bewerten Sie Ihr <span class="marked">Seminar</span> ?`,
        },
        comment: {
          label: `Was war der Grund, der zu Ihrer Bewertung geführt hat?`,
          placeholder: `Kommentar eingeben...`,
          guidance: {
            label: `Hilfestellung für Ihre Bewertung`, //nach dem doppelpunkt gucken war inkonsistent
            h1: `Was halten Sie von der Qualität Ihres Seminars?`,
            h2: `Hat das Seminar Ihre Erwartungen erfüllt?`,
            h3: `Wie fanden Sie Unterlagen und Technik?`,
            h4: `Wie wird das Seminar Ihre Produktivität bei der Arbeit verbessern?`,
          },
        },
      },
      gfu: {
        rating: {
          label: `Wie zufrieden sind Sie mit der <span class="marked">GFU</span> als Seminaranbieter?`,
        },
        comment: {
          label: `Bitte beschreiben Sie Ihre Erfahrung bei der GFU`,
          placeholder: `Kommentar eingeben...`,
          guidance: {
            label: `Hilfestellung für Ihre Bewertung`, //nach dem doppelpunkt gucken war inkonsistent
            h1: `Wie zufrieden sind Sie mit dem Buchungsprozess und der Organisation rund ums Seminar?`,
            h2: `Womit sind Sie besonders zufrieden und was könnte optimiert werden?`,
            h3: `Warum würden Sie die GFU weiterempfehlen?`,
          },
        },
      },
      furtherInterest: {
        label: `Welche Seminarthemen interessieren Sie in der Zukunft?`,
        placeholder: "Enter Comment...",
        guidance: {
          label: `GFU bietet 1800+ Seminare in`,
          h1: `Projekt-management`,
          h2: `Data Science`,
          h3: `Programmierung`,
          h4: `Web-Technologien`,
          h5: `Betriebssyteme`,
          h6: `Datenbanken`,
          h7: `Anwendungen`,
          h8: `Server Dienste`,
          h9: `Cloud`,
          h10: `Personalentwicklung`,
        },
      },
      anonymization: {
        label: `Darstellung Ihrer Bewertung in unseren Marketingkanälen`,
        name: {
          label: `Dürfen wir Ihren Namen anzeigen?`,
          optionFullName: {
            label: `Vollständig`,
            sample: `Max Mustermann`,
          },
          optionAbbreviated: {
            label: `Abgekürzt`,
            sample: `Max M.`,
          },
          optionHideName: {
            label: `Gar nicht`,
            sample: ``,
          },
        },
        company: {
          label: `Dürfen wir den Namen Ihrer Firma anzeigen?`,
          optionYes: {
            label: `Ja`,
            sample: `Muster GmbH`,
          },
          optionNo: {
            label: `Nein`,
            sample: ``,
          },
        },
      },
      suggestions: {
        label: `Welchen Rat würden Sie dem GFU-Team für eine noch bessere Leistung geben`,
        appendum: `und welche Rolle sollte KI dabei aus Ihrer Sicht künftig spielen?`,
      },
      sampleReviews: {
        label: `Typische Bewertungen in jüngster Zeit`,
        showMore: `Weitere anzeigen`,
        r1: `Das Seminar hat meine Erwartungen mehr als erfüllt. Die Qualität war
          durchgehend hoch und es gab viel Know-How direkt aus der Praxis. Sehr
          gute Erklärungen, gute fachliche Untermauerung. Sehr hoher Praxisbezug
          in der Umsetzung. Der theoretische Hintergrund wurde sehr gut und
          verständlich erläutert. Gute technische Ausstattung der Räume, Catering
          sehr gut, 86" Monitore funktionieren erstaunlich gut an Stelle eines
          Beamers.`,
        r2: `Das beeindruckende Verpflegungsangebot, die freundlichen und
          zuvorkommenden Mitarbeiter und die wirklich zuverlässigen
          Schulungsrechner haben ein perfektes Bild der GFU erzeugt so dass ich
          sie unbedingt weiterempfehlen werde.`,
        r3: `War alles super organisiert. Gute Arbeitsmaterialien. Gutes Seminar.
          Leckerer Kaffee und Snacks. Die TÜV Mensa ist natürlich der Hammer, auch
          wenn es immer zu viel war.`,
        r4: `Das ist jetzt mein 12. Besuch bei der GFU, ich wüsste nicht, was man
          noch besser machen könnte. Und die Versorgung mit Essen und Getränken
          ist auf Champions League-Niveau :)`,
        r5: `+ Der Kaffee ist super lecker.<br />
          + Das Essen war immer mindestens Durchschnitt eher besser als
          Durchschnitt.<br />
          + Ein Shuttle würde einen zum Bahnhof bringen oder abholen.<br />
          + Alle hier sind sehr nett und hilfsbereit.<br />
          + Man bekommt alles gestellt und braucht nie was mitnehmen.<br />
          !!!! Einfach alles Superklasse !!!!!`,
        r6: `Die GFU hat einen hervorragenden Eindruck hinterlassen.
          Schulungsumgebung, Betreuung der Seminarteilnehmer und auch der
          Trainer waren auf einem absoluten top Niveau. Ich würde die GFU
          jederzeit gerne weiterempfehlen.`,
        r7: `Perfekte Organisation. Schulungsräume super ausgestattet, Bewirtung
          'unglaublich gut' und die GFU-Mitarbeiter super freundlich :)<br />
          Empfehlung? Auf jeden Fall`,
        r8: `- Perfekt organisiert<br />
          - Viele Goodies wie Gratis Buch, Snack Bar, Getränke<br />
          - Shuttle Dienst<br />
          - Sehr gute Kantine die gratis genutzt werden darf.<br />
          - Angenehmes Klima trotz Sommer<br />
          - Gute Hardware (PCs)`,
        r9: `Die Schulung war sehr praxisnah, gut strukturiert und lehrreich. Der
          Dozent hatte sehr viel Praxiserfahrung und konnte sich sehr gut auf
          die Hintergründe der Teilnehmer einstellen und passende Beispiele und
          Lösungen für die jeweiligen Teilnehmersituationen "aus dem Hut
          zaubern".`,
        r10: `GFU ist eine sehr gute Location mit guten Trainern und hervorragend
          ausgestatteten Räumen. Auch die super Verpflegung ist zu erwähnen.`,
      },
      validation: {
        required: `ist ein Pflichtfeld`,
        fields: {
          trainerRating1: `Die Bewertung`,
          trainerRating2: `Die Bewertung`,
          seminarRating: `Die Seminar-Bewertung`,
          gfuRating: `Die Bewertung`,
        },
      },
    },
    newsletter: {
      legend: `Keinen Trend verpassen!`,
      freeBook: `Gratis Fachbuch`,
      introduction: {
        heading: `50€ Buchgutschein für Newsletter Abonnenten`,
        text: `Melden Sie sich für unseren gratis Newsletter an und erhalten Sie
          einen Buchgutschein in Höhe von EUR 50 für ein Fachbuch Ihrer Wahl -
          einzulösen bei Ihrem nächsten Seminarbesuch bei der GFU Cyrus AG.`,
      },
      subscribe: {
        label: `Dürfen wir Sie in unseren Newsletter eintragen?`,
      },
      form: {
        label: `E-Mail`,
        placeholder: `E-Mail eintragen...`,
        option1: {
          heading: `Buchgutschein`,
          text: `Ja, ich möchte für meine Anmeldung zum Newsletter einen
              Buchgutschein im Wert von EUR 50 erhalten. Ich versichere, dass
              ich kein Amtsträger i.S.v. § 11 Abs. 1 Nr. 2 StGB bin. Ferner
              versichere ich, dass mir die Annahme von Vorteilen von meinem
              Arbeitgeber nicht untersagt wurde.`,
        },
        option2: {
          heading: `Newsletter Standard`,
          text: `Ich bin damit einverstanden, dass die GFU Cyrus AG meine
              vorstehenden Daten für die Zusendung ihres
              <strong>allgemeinen Newsletters</strong> und sonstiger
              <strong>allgemeiner Marketingkommunikation</strong>
              (Informationen über Seminare, Vorträge &amp; Events, Fachartikel,
              Gewinnspiele, Rabattaktionen etc.) speichert und nutzt. Meine
              vorstehende Einwilligung in die Datenverarbeitung zu Werbezwecken
              kann ich jederzeit mit Wirkung für die Zukunft widerrufen, indem
              ich den Abmeldelink in der Werbe-Email anklicke oder eine Email an
              <a href="mailto:newsletterabmeldung@gfu.net"
                >newsletterabmeldung@gfu.net</a
              >
              sende. Ich habe die Hinweise zum
              <a href="https://www.gfu.net/datenschutz.html">Datenschutz</a>
              zur Kenntnis genommen.`,
        },
        option3: {
          heading: `Newsletter Standard + Personalisiert`,
          text: `Ich bin damit einverstanden, dass die GFU Cyrus AG meine
              vorstehenden Daten für die Zusendung ihres allgemeinen Newsletters
              und sonstiger allgemeiner Marketingkommunikation sowie bestimmte
              weitere Daten (z.B. zu meinen bisherigen Seminarbesuchen und zum
              Newsletter-Klickverhalten, für weitere Details siehe die Hinweise
              zum
              <a href="https://www.gfu.net/datenschutz.html">Datenschutz</a>)
              für die Zusendung eines auf meine Interessen zugeschnittenen
              <strong>personalisierten Newsletters</strong> und sonstiger
              <strong>personalisierter Marketingkommunikation</strong>
              (Informationen über Seminare, Vorträge &amp; Events, Fachartikel,
              Gewinnspiele, Rabattaktionen etc.) speichert und nutzt. Meine
              vorstehende Einwilligung in die Datenverarbeitung zu Werbezwecken
              kann ich jederzeit mit Wirkung für die Zukunft widerrufen, indem
              ich den Abmeldelink in der Werbe-Email anklicke oder eine Email an
              <a href="mailto:newsletterabmeldung@gfu.net"
                >newsletterabmeldung@gfu.net</a
              >
              sende. Ich habe die Hinweise zum
              <a href="https://www.gfu.net/datenschutz.html">Datenschutz</a>
              zur Kenntnis genommen.`,
        },
      },
    },
  },
};

const i18n = new VueI18n({
  locale: localStorage.getItem("locale") || "de", // set locale
  fallbackLocale: "de", // set fallback locale
  messages, // set locale messages
});

export default i18n;
